import Vue from 'vue'
import Router from 'vue-router'

import Home from './components/Home.vue'
import Time from './components/Time.vue'
import Fortune from './components/Fortune.vue'
import Login from './components/Login.vue'

import Store from '@/store/index.js'

Vue.use(Router)

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home
        },
        {
            path: '/fortune',
            name: 'fortune',
            component: Fortune,
            meta : { requiresAuth: true}
        },
        {
            path: '/time',
            name: 'time',
            component: Time
        },
        {
            path: '/login',
            name: 'login',
            component: Login
        }
    ]
})

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth) &&  !Store.state.userToken) {
      next({ path: '/login', query: { redirect: to.fullPath } });
    } else {
      next();
    }
  });

export default router